<template>
<!--  사용안함-->
  <div>
    <input type="radio" id="item.key" name="patinent_select">
    <label for="item.key"><span></span></label>
  </div>
</template>
<script>
  export default {
    name: 'RadioBox',
    props: [ 'item' ],

    data() {
      return {}
    },
  }
</script>